import { makeStyles, Theme } from '@material-ui/core/styles';

// Card geometry is duplicated from CalculationFirstStep.styles.ts on purpose:
// sharing one style factory between the two sheets changed JSS rule order and
// broke the real form's spacing.
export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: '0 24px 64px',
    [theme.breakpoints.down('xs')]: {
      padding: '0 0 64px',
    },
  },
  formContainer: {
    backgroundImage: 'url(./images/backgrounds/firstStep.svg)',
    backgroundPosition: '50% -10px',
    backgroundRepeat: 'no-repeat',
    paddingTop: 16,
    [theme.breakpoints.down(1024)]: {
      backgroundImage: 'none',
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: 0,
    },
  },
  formWrapper: {
    boxShadow: theme.custom.shadow[4],
    borderRadius: 12,
    padding: 40,
    maxWidth: 540,
    minHeight: 332,
    margin: '0 auto',
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      boxShadow: 'none',
      padding: '0 20px 20px',
      minHeight: 'auto',
    },
  },
  legalLinks: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    marginTop: 24,
    [theme.breakpoints.down('xs')]: {
      padding: '0 20px',
    },

    '& div': {
      maxWidth: 483,
    },
  },
  formFooter: {
    padding: '40px 0 24px',
  },
  helpSection: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  helpSectionTitle: {
    fontSize: 22,
    fontWeight: 700,
    lineHeight: '26px',
    fontFamily: 'Lato, sans-serif',
    marginTop: 18,
    marginBottom: 24,
  },
  callMeBackButton: {
    borderRadius: '100px !important',
    fontSize: 18,
    fontWeight: 700,
    lineHeight: '22px',
    padding: '14px 24px',
    [theme.breakpoints.down('xs')]: {
      margin: '0 auto',
    },
  },
  callMeBackButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 15,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: '100%',
    },
  },
  callMeBackButtonText: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      margin: '0 auto',
    },
  },
  icon: {
    marginRight: 10,
    fill: theme.palette.primary.main,
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    fontSize: 22,
    fontWeight: 700,
    lineHeight: '26px',
  },
}));
